export default function aspectRatio({
  originalWidth,
  originalHeight,
  desiredWidth,
  desiredHeight,
}: {
  originalWidth: number;
  originalHeight: number;
  desiredWidth?: number;
  desiredHeight?: number;
}) {
  if (desiredWidth) {
    return {
      width: desiredWidth,
      height: (desiredWidth / originalWidth) * originalHeight,
    };
  }
  if (desiredHeight) {
    return {
      width: (desiredHeight / originalHeight) * originalWidth,
      height: desiredHeight,
    };
  }
  return {
    width: originalWidth,
    height: originalHeight,
  };
}
